import config from '../../config'
import store from '../store'

export default {
  namespaced: true,
  state: {
    revendedores: [],
    saiVendedores: [],
    solicitudes: [],
    solicitudSeleccionada: null,
    permisos: {
      abm_gestion: false,
      consultas_reasignar: false
    },
    loading: false,
    loadingSolicitudes: false
  },
  mutations: {
    set_revendedores(state, payload) {
      state.revendedores = payload
    },
    set_sai_vendedores(state, payload) {
      state.saiVendedores = payload
    },
    set_loading(state, payload) {
      state.loading = payload
    },
    set_loading_solicitudes(state, payload) {
      state.loadingSolicitudes = payload
    },
    add_revendedor(state, payload) {
      state.revendedores.push(payload)
    },
    update_revendedor(state, payload) {
      const index = state.revendedores.findIndex(r => r.id === payload.id)
      if (index !== -1) {
        state.revendedores.splice(index, 1, payload)
      }
    },
    remove_revendedor(state, id) {
      state.revendedores = state.revendedores.filter(r => r.id !== id)
    },
    set_solicitudes(state, payload) {
      state.solicitudes = payload
    },
    set_solicitud_seleccionada(state, payload) {
      state.solicitudSeleccionada = payload
    },
    set_permisos(state, payload) {
      state.permisos = {
        ...state.permisos,
        ...(payload || {})
      }
    },
    update_solicitud(state, payload) {
      const index = state.solicitudes.findIndex(s => s.id === payload.id)
      if (index !== -1) {
        state.solicitudes.splice(index, 1, payload)
      }
      if (state.solicitudSeleccionada && state.solicitudSeleccionada.id === payload.id) {
        state.solicitudSeleccionada = payload
      }
    }
  },
  actions: {
    async fetch_permisos({ commit }) {
      try {
        const res = await fetch(`${config.API_URL}/revendedores/permisos`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await res.json()

        if (data.exito == 1) {
          commit('set_permisos', data.permisos)
          return data.permisos
        }

        commit('set_permisos', { abm_gestion: false, consultas_reasignar: false })
        return { abm_gestion: false, consultas_reasignar: false }
      } catch (error) {
        commit('set_permisos', { abm_gestion: false, consultas_reasignar: false })
        return { abm_gestion: false, consultas_reasignar: false }
      }
    },

    async fetch_revendedores({ commit }, filtros = {}) {
      commit('set_loading', true)
      try {
        const params = new URLSearchParams()
        if (filtros.nombre) params.append('nombre', filtros.nombre)
        if (filtros.telefono) params.append('telefono', filtros.telefono)
        if (filtros.email) params.append('email', filtros.email)
        params.append(
          'inhabilitado',
          filtros.inhabilitado !== undefined ? filtros.inhabilitado : 0
        )

        const res = await fetch(
          `${config.API_URL}/revendedores/search?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('set_revendedores', data.data)
        } else {
          commit('set_revendedores', [])
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
        }
      } catch (error) {
        commit('set_revendedores', [])
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      } finally {
        commit('set_loading', false)
      }
    },

    async fetch_sai_vendedores({ commit }, currentRevendedorId = null) {
      try {
        const params = new URLSearchParams()
        if (currentRevendedorId) {
          params.append('current_revendedor_id', currentRevendedorId)
        }

        const query = params.toString() ? `?${params.toString()}` : ''
        const res = await fetch(
          `${config.API_URL}/revendedores/sai-vendedores${query}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('set_sai_vendedores', data.data)
        } else {
          commit('set_sai_vendedores', [])
        }
      } catch (error) {
        commit('set_sai_vendedores', [])
      }
    },

    async fetch_revendedor({}, id) {
      try {
        const res = await fetch(`${config.API_URL}/revendedores/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          }
        })

        const data = await res.json()

        if (data.exito == 1) {
          return data.data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      }
    },

    async create_revendedor({ commit }, payload) {
      try {
        const res = await fetch(`${config.API_URL}/revendedores`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        const data = await res.json()

        if (data.exito == 1) {
          commit('add_revendedor', data.data)
          return true
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return false
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return false
      }
    },

    async update_revendedor({ commit }, { id, payload }) {
      try {
        const res = await fetch(`${config.API_URL}/revendedores/${id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: store.state.token
          },
          body: JSON.stringify(payload)
        })

        const data = await res.json()

        if (data.exito == 1) {
          commit('update_revendedor', data.data)
          return true
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return false
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return false
      }
    },

    async inhabilitar_revendedor({ commit }, id) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/${id}/inhabilitar`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('remove_revendedor', id)
          return true
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return false
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return false
      }
    },

    async sincronizar_builderbot({}, id) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/${id}/sincronizar-builderbot`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Sincronización exitosa',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      }
    },

    async verificar_builderbot({}) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/verificar-builderbot`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          store.dispatch('show_snackbar', {
            text: data.message || 'Verificación completada',
            color: 'success'
          })
          return data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      }
    },

    // ── Solicitudes ─────────────────────────────────────────────

    async fetch_revendedores_lista() {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/lista`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          return data.data
        } else {
          return []
        }
      } catch (error) {
        return []
      }
    },

    async fetch_usuarios_asignables({ commit }) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/usuarios-asignables`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          return data.data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return []
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return []
      }
    },

    async fetch_solicitudes({ commit }, filtros = {}) {
      commit('set_loading_solicitudes', true)
      try {
        const params = new URLSearchParams()
        if (filtros.estado) params.append('estado', filtros.estado)
        if (filtros.sector_destino) params.append('sector_destino', filtros.sector_destino)
        if (filtros.revendedor) params.append('revendedor', filtros.revendedor)
        if (filtros.revendedor_id) params.append('revendedor_id', filtros.revendedor_id)
        if (filtros.asesor_asignado_id !== null && filtros.asesor_asignado_id !== undefined && filtros.asesor_asignado_id !== '') {
          params.append('asesor_asignado_id', filtros.asesor_asignado_id)
        }

        const res = await fetch(
          `${config.API_URL}/revendedores/solicitudes?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('set_solicitudes', data.data)
        } else {
          commit('set_solicitudes', [])
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
        }
      } catch (error) {
        commit('set_solicitudes', [])
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      } finally {
        commit('set_loading_solicitudes', false)
      }
    },

    async tomar_solicitud({ commit }, id) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/solicitudes/${id}/tomar`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('update_solicitud', data.data)
          commit('set_solicitud_seleccionada', data.data)
          return data.data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return null
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return null
      }
    },

    async update_solicitud({ commit }, { id, payload }) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/solicitudes/${id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify(payload)
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('update_solicitud', data.data)
          commit('set_solicitud_seleccionada', data.data)
          return data.data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return null
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return null
      }
    },

    async reasignar_solicitud({ commit }, { id, asesor_asignado_id }) {
      try {
        const res = await fetch(
          `${config.API_URL}/revendedores/solicitudes/${id}/reasignar`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({ asesor_asignado_id })
          }
        )

        const data = await res.json()

        if (data.exito == 1) {
          commit('update_solicitud', data.data)
          commit('set_solicitud_seleccionada', data.data)
          return data.data
        } else {
          store.dispatch('show_snackbar', {
            text: data.message,
            color: 'error'
          })
          return null
        }
      } catch (error) {
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
        return null
      }
    }
  }
}
